import React, { Component } from 'react';
import { ExtendedFormCategory } from '../../components/suggestions';
import SuggestionsExtendedStore from '../../stores/SuggestionsExtendedStore';

class ExtendedFormCategoriesContainer extends Component {
  state = {
    categories: SuggestionsExtendedStore.getCategories(),
    mainCategory: '',
    subCategory: '',
  };

  setMainCategory = (newMainCategory) => {
    const { mainCategory } = this.state;
    if (newMainCategory === mainCategory) {
      return;
    }

    this.setState({
      mainCategory: newMainCategory,
      subCategory: '',
    });

    SuggestionsExtendedStore.setMainCategory(newMainCategory);
    SuggestionsExtendedStore.setSubCategory('');
    SuggestionsExtendedStore.setQuestionsAndFormData();
    SuggestionsExtendedStore.setAttachments({});
    SuggestionsExtendedStore.setShowErrors(false);
    SuggestionsExtendedStore.setSubmitStatus(null);
    SuggestionsExtendedStore.emitChange();
  };

  setSubCategory = (newSubCategory) => {
    const { subCategory } = this.state;
    if (newSubCategory === subCategory) {
      return;
    }

    this.setState({ subCategory: newSubCategory });

    SuggestionsExtendedStore.setSubCategory(newSubCategory);
    SuggestionsExtendedStore.setQuestionsAndFormData();
    SuggestionsExtendedStore.setAttachments({});
    SuggestionsExtendedStore.setShowErrors(false);
    SuggestionsExtendedStore.setSubmitStatus(null);
    SuggestionsExtendedStore.emitChange();
  };

  render() {
    const {
      categories,
      mainCategory,
      subCategory,
    } = this.state;

    const showMain = [];
    Object.keys(categories.main).forEach((categoryId) => {
      showMain.push(
        <ExtendedFormCategory
          key={categoryId}
          id={categoryId}
          active={mainCategory === categoryId}
          setCategory={this.setMainCategory}
          title={categories.main[categoryId]}
        />,
      );
    });

    if (!mainCategory || !Object.prototype.hasOwnProperty.call(categories.sub, mainCategory)) {
      return (
        <div className="ptm pbm bb">{showMain}</div>
      );
    }

    const showSub = [];
    Object.keys(categories.sub[mainCategory]).forEach((subCategoryId) => {
      showSub.push(
        <ExtendedFormCategory
          key={subCategoryId}
          id={subCategoryId}
          active={subCategory === subCategoryId}
          setCategory={this.setSubCategory}
          title={categories.sub[mainCategory][subCategoryId]}
        />,
      );
    });

    return (
      <div>
        <div className="ptm pbm bb">{showMain}</div>
        <div className="ptm pbm bb">{showSub}</div>
      </div>
    );
  }
}

export default ExtendedFormCategoriesContainer;
